import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import getRowConfig from 'pages/ValuationsAllocation/approaches/TransactionComps/config/getRowConfig';
import parser from 'pages/ValuationsAllocation/approaches/TransactionComps/config/parser';
import reverseParser from 'pages/ValuationsAllocation/approaches/TransactionComps/config/reverseParser';
import rowTransformer from 'pages/ValuationsAllocation/approaches/TransactionComps/config/rowTransformer';
import { CreateTransactionCompsData } from 'pages/ValuationsAllocation/approaches/TransactionComps/types';
import { getBooleanValue, getObjectValue, getStringValue } from 'utilities';
import afterCellChanged from './afterCellChanged';
import validations from './validations';

const createTransactionCompsData = (params: CreateTransactionCompsData) => {
  const {
    approach,
    name,
    companyInfo,
    financials,
    format,
    compGroups,
    transactionCompsAttributes,
    isDisabled,
    gpcApproaches,
    gpcOptions,
  } = params;
  const companyName = getStringValue(companyInfo?.name);
  const rowConfig = getRowConfig({
    companyName,
    approach: getObjectValue(approach.valuations_approach_gpt),
    allCompGroups: compGroups,
    isDisabled: getBooleanValue(isDisabled),
    gpcOptions,
  });

  const getColumns = () => rowTransformer({ approach: getObjectValue(approach.valuations_approach_gpt), financials });
  const columns = getColumns();

  const tableTerms = {
    tableSlug: 'valuation-table',
  };

  return new SpreadsheetConfig({
    columns,
    rowConfig,
    parser,
    reverseParser: reverseParser as unknown as SpreadsheetConfig['reverseParser'],
    name,
    tableData: { approach, companyName, isDisabled, gpcApproaches, gpcOptions, financials },
    showToolbar: true,
    afterCellChanged: afterCellChanged as unknown as SpreadsheetConfig['afterCellChanged'],
    allowConfirmAndDeleteColumn: false,
    tableTerms: tableTerms as unknown as SpreadsheetConfig['tableTerms'],
    format,
    fieldAttributes: transactionCompsAttributes,
    customValidations: validations as unknown as SpreadsheetConfig['customValidations'],
    allowCopyRows: !isDisabled,
    allowAddMultipleRows: !isDisabled,
    allowDeleteRow: !isDisabled,
    getColumns,
    totalParser: undefined,
  });
};

export default createTransactionCompsData;
